/**
* Video Player JS
* -----------------------------------------------------------------------------
*
* All the JS for the Video Player component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import Plyr from 'plyr';
( function( app ) {
  const COMPONENT = {

    className: 'video-player',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      const controls = `
        <div class="plyr__controls">
          <div class="flex justify-between items-center w-full">
            <div class="video-navigation flex-initial">
              <button type="button" class="plyr__control" data-plyr="rewind">
                  <svg role="presentation"><use xlink:href="#plyr-rewind"></use></svg>
                  <span class="plyr__tooltip" role="tooltip">Rewind {seektime} secs</span>
              </button>
              <button type="button" class="plyr__control" aria-label="Play, {title}" data-plyr="play">
                  <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg>
                  <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg>
                  <span class="label--pressed plyr__tooltip" role="tooltip">Pause</span>
                  <span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span>
              </button>
              <button type="button" class="plyr__control" data-plyr="fast-forward">
                  <svg role="presentation"><use xlink:href="#plyr-fast-forward"></use></svg>
                  <span class="plyr__tooltip" role="tooltip">Forward {seektime} secs</span>
              </button>
            </div>

            <div class="title flex-1 mx-4 md:mx-16 text-left">
              <p class="text-sm font-medium">{{Now playing: TITLE}}</p>
              <p class="text-xs">{{SUBTITLE}}</p>
            </div> <!-- /.title -->

            <div class="time flex-initial flex">
              <div class="plyr__time plyr__time--current" aria-label="Current time">00:00</div>
              <div class="plyr__time plyr__time--duration" aria-label="Duration">00:00</div>
            </div>
          </div>

          <div class="plyr__progress">
              <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek">
              <progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress>
              <span role="tooltip" class="plyr__tooltip">00:00</span>
          </div>

        </div>
        `;
      // $( '.video-player' ).each( function() {
      //   const player = new Plyr( $( this ).find( '.plyr' )[0], {
      //     debug: true,
      //     muted: true,
      //     hideControls: false,
      //     controls: controls,
      //   } );
      // } );

      let player;
      $( '.video-popup-button' ).magnificPopup( {
        type: 'inline',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            let thisControls = controls;
            const title = $( '.mfp-wrap .video-player' ).find( '.video-wrapper' ).attr( 'data-title' );
            console.log( title );
            const subtitle = $( '.mfp-wrap .video-player' ).find( '.video-wrapper' ).attr( 'data-subtitle' );
            if ( title.length ) {
              thisControls = thisControls.replace( '{{Now playing: TITLE}}', 'Now playing: ' + title );
            } else {
              thisControls = thisControls.replace( '{{Now playing: TITLE}}', '' );
            }
            if ( subtitle.length ) {
              thisControls = thisControls.replace( '{{SUBTITLE}}', subtitle );
            } else {
              thisControls = thisControls.replace( '{{SUBTITLE}}', '' );
            }
            player = new Plyr( $( '.mfp-wrap .video-player' ).find( '.plyr' )[0], {
              controls: thisControls,
            } );
          },
          close: function() {
            player.pause();
            player.destroy();
          },
        },
      } );

      function secondsTimeSpanToHMS( s ) {
        const m = Math.floor( s/60 );
        s -= m*60;
        return ( m < 10 ? '0'+m : m )+':'+( s < 10 ? '0'+s : s );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'video-player', COMPONENT );
} )( app );
